module.exports = __webpack_public_path__ + "img/win.2cfef7d8.png";